import { FunctionComponent } from 'react';
import { SUEmailReceivedModal } from 'widgets/auth/signUp/EmailReceivedModal';

export const SignUpEmailReceived: FunctionComponent = () => {
	return <SUEmailReceivedModal />;
};
